import React, { useEffect, useState } from 'react'
import { Button, Form, Modal, Select } from 'semantic-ui-react'
import agent from '../../../app/api/agent';
import { useStore } from '../../../app/stores/store';
import { toast } from 'react-toastify';
import { observer } from 'mobx-react-lite';
import { HFCServiceInfoInitialdata, HFCShipperInfo, HFCShipperInfoInitialdata } from '../../../app/models/ReceivingDelivery';
import { historyInitialState } from '../../../app/models/history';
// import { historyInitialState } from '../../../app/models/history';


interface Props {
    isModal: boolean;
    setIsModal: React.Dispatch<React.SetStateAction<boolean>>;
    scanData: any;
    setIssubmit: React.Dispatch<React.SetStateAction<boolean>>;
    receiving?: HFCShipperInfo;
    barcode?:any,
}


const MovetoVaultModal: React.FC<Props> = ({ isModal, setIsModal,  scanData, setIssubmit, receiving, barcode}) => {

    const { vaultStore:{ HFCvaultList}, userStore, activityStore, dashboardStore,viewStore: { deleteCircuit }} = useStore();
    const [roomOptions, setRoomOptions] = useState<string[]>([]);
    const [aisleOptions, setAisleOptions] = useState<string[]>([]);
    const [shelfOptions, setShelfOptions] = useState<string[]>([]);
    const [selectedVault, setSelectedVault] = useState<string >('');
    const [selectedRoom, setSelectedRoom] = useState<string>('');
    const [selectedAisle, setSelectedAisle] = useState<string>('');
    const[selectedShelf, setSelectedShelf] = useState<string>('');
    const[selectedVaultText, setSelectedVaultText] = useState<string>('');
    const[selectedScanData, setSelectedScanData] = useState<string[]>([])
    const [isFormValid, setIsFormValid] = useState<boolean>(false);

    useEffect(() => {
        const isValid = validateFormValues();
        setIsFormValid(isValid);
         // eslint-disable-next-line
    }, [selectedVault, selectedRoom, selectedAisle, selectedShelf, selectedScanData]);
    
    useEffect(() => {
        const fetchData = async () => {
            if (selectedVault !== undefined && selectedVault !== "") {
                const filteredArray:any = [];
                HFCvaultList.forEach((x: any) => {
                    if (x.value === selectedVault) {
                        filteredArray.push(x);
                    }
                });
                const res= await agent.HFC.HFCRoom(filteredArray[0].key)
                const room = res.data
                const list = room.map((item: any) => {
                    return {
                        key: item, 
                        text: item, 
                        value: item 
                    };
                });
                setRoomOptions(list);
            }
        };
        fetchData();
    }, [selectedVault, HFCvaultList]); 

    useEffect(() => {
        const fetchData = async () => {
            if (selectedRoom !== undefined && selectedRoom !== "") {
                // await getAisleList(selectedVault, selectedRoom);
                const filteredArray:any = [];
                HFCvaultList.forEach((x: any) => {
                    if (x.value === selectedVault) {
                        filteredArray.push(x);
                    }
                });
                const res = await agent.HFC.HFCAisle(filteredArray[0].key, selectedRoom)
                const aisle = res.data
                const aisleList= aisle.map((item:any)=>{
                    return{
                        key:item,
                        text:item,
                        value:item
                    }
                })
                setAisleOptions(aisleList)
            }
        };
        fetchData();
        // eslint-disable-next-line
    }, [selectedRoom]); 

    useEffect(() => {
        const fetchData = async () => {
            if (selectedAisle !== undefined && selectedAisle !== "") {
                // await getHFCShelfList(selectedVault, selectedRoom, selectedAisle);
                const filteredArray:any = [];
                HFCvaultList.forEach((x: any) => {
                    if (x.value === selectedVault) {
                        filteredArray.push(x);
                    }
                });
               const res =  await agent.HFC.HFCShelf(filteredArray[0].key, selectedRoom, selectedAisle)
               const shelf = res.data
               const shelfList= shelf.map((item:any)=>{
                return{
                    key:item,
                    text:item,
                    value:item
                }
            })
            setShelfOptions(shelfList)
            }
        };
    
        fetchData();
        // eslint-disable-next-line
    }, [selectedAisle]);


    const handleVaultChange = (e: React.ChangeEvent<HTMLInputElement>, data: any) => {
        setSelectedVault(data.value);
        const selectedOption:any = HFCvaultList.find((option: any) => option.value === data.value);
        if (selectedOption) {
            setSelectedVaultText(selectedOption?.text);
        }
        setSelectedRoom('');
        setSelectedAisle('');
        setSelectedShelf('');
    };
    const validateFormValues = () => {
        return (
            selectedVault !== '' &&
            selectedRoom !== '' &&
            selectedAisle !== '' &&
            selectedShelf !== '' &&
            selectedScanData.length > 0
        );
    };
    
    const userID = userStore.user?.id !== undefined ? userStore.user?.id : '';

    const vaultSubmit = async () => {
       
        let payloadHist:any;
        for (const data of selectedScanData) {
            const payload = {
                vault: selectedVaultText,
                room: selectedRoom,
                aisle_No: selectedAisle,
                shelf: selectedShelf
            };
    
            try {
                const res = await agent.HFC.HFCTag(data, payload);
                if(dashboardStore.dashboard.valueForL3Orders !== "Receiving" && dashboardStore.dashboard.valueForL3Orders !== "Returning Services"){
               
                const historyPayload = {
                    ...historyInitialState,
                    itemId: barcode[0],
                    status: `${res.data}`,
                    dateTime: new Date().toISOString(),
                    trackerFromTime: new Date().toISOString(),
                }
                // await agent.HFC.HFCaddHistory(historyPayload)
                payloadHist= {...historyPayload}
                toast.success(`${res.data}`)
                }
            } catch (error) {
                console.error(`Error tagging data ${data}:`, error);
            }
        }
        if(payloadHist){
            try {
            await agent.HFC.HFCaddHistory(payloadHist)
            }catch(error){
                console.error('Error adding history:', error);
            }
        }
        if(dashboardStore.dashboard.valueForL3Orders === "Receiving" || dashboardStore.dashboard.valueForL3Orders === "Returning Services"){
            const res = await agent.HFC.HFCReceivingAsset(receiving?.id)
            if(dashboardStore.dashboard.valueForL3Orders === "Receiving" ){
                const receivingPayload = {
                    ...historyInitialState,
                    itemId: receiving?.asset_ID,
                    status: `"${receiving?.title}" is returned successfully to inventory  from Shipping`,
                    dateTime: new Date().toISOString(),
                    trackerFromTime: new Date().toISOString(),
                }
                await agent.HFC.HFCaddHistory(receivingPayload)
                toast.success(res.data)
            await activityStore.HFCReceivingloadActivitiesPagination(1,userID,5,[])
            activityStore.selectedShipper = HFCShipperInfoInitialdata;
            if (receiving && receiving.asset_ID) {
                deleteCircuit({ itemId: receiving.asset_ID });
            } 
            }
            if(dashboardStore.dashboard.valueForL3Orders === "Returning Services" ){
                const returningPayload = {
                    ...historyInitialState,
                    itemId: activityStore.selectedReturn?.asset_ID,
                    status:`"${activityStore.selectedReturn?.title}" is returned successfully to inventory  from Service Request`, 
                    dateTime: new Date().toISOString(),
                    trackerFromTime: new Date().toISOString(),
                }
                await agent.HFC.HFCaddHistory(returningPayload)
                toast.success(res.data)
                await activityStore.HFCReturningloadActivitiesPagination(1,userID,5,[])
                activityStore.selectedService = HFCServiceInfoInitialdata
                if (receiving && receiving.asset_ID) {
                    deleteCircuit({ itemId: receiving.asset_ID });
                } 
            }            
        }else{
            await activityStore.HFCVaultloadActivitiesPagination(1, userID, 5,[])
        }
       
        setIsModal(false)
        setIssubmit(false)
    };
    


    return (
        <Modal open={isModal}>
            <Modal.Header>
                Move To Vault
            </Modal.Header>
            <Modal.Content>
            <Form>
            <Form.Field 
                clearable
                fluid
                selection
                options={HFCvaultList}
                control={Select}
                label="Vault"
                placeholder="Select Vault"
                onChange={handleVaultChange} 
                value={selectedVault}
            />
            <Form.Field
                clearable
                fluid
                selection
                options={roomOptions}
                control={Select}
                label="Room"
                placeholder="Select Room"
                onChange={(e: React.ChangeEvent<HTMLInputElement>, data: any) => {
                    setSelectedRoom(data.value as string)
                    setSelectedAisle('');
                    setSelectedShelf('');
                }} 
                value={selectedRoom}
            />
            <Form.Field
                clearable
                fluid
                selection
                options={aisleOptions}
                control={Select}
                label="Aisle.No"
                placeholder="Select Aisle.No"
                onChange={(e: React.ChangeEvent<HTMLInputElement>, data: any) => {
                    setSelectedAisle(data.value as string)
                    setSelectedShelf('');
                }} 
                value={selectedAisle}
            />
            <Form.Field
                clearable
                fluid
                search
                selection
                options={shelfOptions}
                control={Select}
                label="Shelf"
                placeholder="Select Shelf"
                onChange={(e: React.ChangeEvent<HTMLInputElement>, data: any) => setSelectedShelf(data.value as string)}  
                value={selectedShelf}
            />
            <Form.Field
                clearable
                fluid
                search
                selection
                multiple  
                options={scanData}
                control={Select}
                label="Container Barcodes"
                placeholder="Select Container Barcodes"
                onChange={(e: React.ChangeEvent<HTMLInputElement>, data: any) => {
                    setSelectedScanData(data.value as string[])}  }
                value={selectedScanData}
            />
            </Form>
            </Modal.Content>
            <Modal.Actions>
                <Button color="black" onClick={() => setIsModal(false)}>
                    Cancel
                </Button>
                <Button
                    content="Submit"
                    labelPosition="right"
                    icon="checkmark"
                    positive
                    disabled={!isFormValid}
                    onClick={vaultSubmit}
                />
            </Modal.Actions>
        </Modal>
    );
}

export default observer(MovetoVaultModal);
